<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner
            :animation-duration="2000"
            :size="80"
            color="#63c2de"
            class="offset-6"
          ></semipolar-spinner>
        </div>
        <div class="row mb-4">
            <div class="col-8 offset-2" style="background: #fff;
    padding: 10px 0px;">
                <form-wizard
                    @on-complete="onComplete"
                    shape="circle"
                    color="#20a0ff"
                    error-color="#ff4949"
                    title="Quiz"
                    subtitle="Flujo"
                    >
                        <tab-content :title="'Pregunta '+(index+1)"   v-for="(question,index) in questions"  :key="index" icon="fas fa-tasks"  >
                            <h2 class="mb-4 pt-4 text-center">{{question.question}}</h2>
                            <div class="row mb-4 p-auto" style="padding: 0px 25%;">
                                <img
                                
                                class="navbar-brand-full"
                                src="img/lapto.jpg"
                                width="300"
                                alt="Apache Logo"
                            />
                            </div>
                            
                            <b-form-checkbox
                                v-for="(option,index) in question.options"
                                :key="index+'-option'"
                                v-model="option.value"
                                name="checkbox-5"
                                @change="changeWizard()"
                                class="mb-2 check-ans"
                                :style="`height: 50px;width: 100%; padding-left: 100px; padding-top:10px;border-radius:10px;background: ${option.value?'rgb(32, 160, 255)':'#f3f3f3'};padding: 10px 10px;`"
                            >
                                {{option.option}}
                            </b-form-checkbox>
                        </tab-content>
                </form-wizard>
            </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
export default {
  name: "Quizes",
  components: { SemipolarSpinner,FormWizard, TabContent },
  data: () => {
    return {
      items: [],
      isLoading: false,
      questions: [
        {
            question: "¿Pregunta 1?",
            options: [{option: "Respuesta 1",value: false},{option: "Respuesta 2",value: false},{option: "Respuesta 2",value: false}]
        },
        {
            question: "¿Pregunta 2?",
            options: [{option: "Respuesta 1",value: false},{option: "Respuesta 2",value: false},{option: "Respuesta 2",value: false}]
        },
        {
            question: "¿Pregunta 3?",
            options: [{option: "Respuesta 1",value: false},{option: "Respuesta 2",value: false},{option: "Respuesta 2",value: false}]
        }
      ]
    };
  },
  mounted() {
    this.getQuizes();
    var nav = document.getElementsByClassName("wizard-nav")[0];
    var nav_header = document.getElementsByClassName("wizard-header")[0];
    var nav_top = document.getElementsByClassName("wizard-progress-with-circle")[0];
    nav.style.display = "none";
    nav_header.style.display = "none";
    nav_top.style.top = "-10px";
  },
  methods: {
    getQuizes() {
      var quizes= store.getters.getQuizes;
      if (quizes.length == 0) {
        this.isLoading = true;
        store.dispatch("getQuizes").then(() => {
          quizes = store.getters.getQuizes;
          this.isLoading = false;
          this.quizes = quizes;
        });
      } else {
        this.quizes = quizes;
      }
    },
    onComplete(e){
        alert('done');
    },
    changeWizard(){
        console.log("epa")
        var nav = document.getElementsByClassName("wizard-footer-right")[0].getElementsByClassName("wizard-btn")[0];
        nav.click()
    }
  }
};
</script>
<style >
.wizard-nav {
    display:none !important; 
}

.check-ans {
    padding-left: 40px !important;
    font-size: 20px !important;
}

.check-ans .custom-control-label::before{
    height: 20px;
    top: 5px;
    width: 20px;
}
</style>
